import * as React from 'react';
import * as l from "lenovo";
import DTM = l.DTM;


const getMedia = () => {
    if (matchMedia("(min-width: 1200px)").matches)
        return 4;
    if (matchMedia("(min-width: 992px)").matches)
        return 2;
    return 1;
}

const Satellite = (title, index) => {
    var lmd = window["lmd"];
    var satellite = window["_satellite"];
    var size = getMedia();
    var col = index % size + 1;
    var row = Math.ceil((index + 1) / size);
    lmd.tilelocation = "Row " + row + " Col " + col;
    lmd.linkname = title;
    if (satellite)
        satellite.track("contact-us-tile-clicked");
};

const Tile = ({ props, onClick }) => {
    let noLink = 'javascript:void(0)';
    let linkUrl = (props.LinkUrl !== '' && props.TypeKey === 'Link') ? props.LinkUrl : noLink;
    let linkTarget = props.LinkUrlType == 2 ? '_blank' : '_self';
    let recommendedStyle = props.recommended ? {} : { display: 'none' };
    // added to support premier
    let iconPremier = "";
    let titleClass = "title";
    if (props.SpecialSupport) {
        iconPremier = props.SpecialSupport.toLocaleLowerCase();
        titleClass = 'title ' + iconPremier;
    }
    //contactus or pdtree contactus
    let tileCSName = 'col-xs-12 col-sm-6 col-md-4 col-lg-3 tile-wrapper';
    let tilePDName = 'col-xs-12 tile-wrapper';
    let tileItemName = props.isPDtree ? tilePDName : tileCSName;
    let IsContactUs = props.IsContactUs || false;
    let handleLinkClicked = (event) => {
        if (IsContactUs) {
            let warranty = !props.product.Serial ? "No Warranty" : props.product.WarrantyInfo.warrantyStatus === 'Expired' ? "Out Warranty" : "In Warranty";
            DTM.push({
                type: "eSupportProcess_Initiate",
                name: props.Title,
                action: "Button Click",
                eSupportContactUsInfo: {
                    pageVersion: warranty,
                    pageBrand: props.product.ProductBrand,
                    placement: props.postion,
                    contactusSection: props.IsPSP == true ? "PSP" : "Contact Us",
                }
            });
        }
        Satellite(props.TitleEn || props.Title, props.Index);
        let target = event.currentTarget;
        if (target.href === noLink) {
            event.preventDefault();
            onClick(props.TypeKey, props.Index);
        }
    };
    let iconShow = /\.svg$/.test(props.OptionIcon)
        ?
        <div className='icon icon-svg'>
            <embed src={props.OptionIcon} width="100" height="36" type="image/svg+xml" pluginspage="http://www.adobe.com/svg/viewer/install/" />
        </div>
        :
        <div className='icon'>
            <span className={'icon-webfont ' + props.OptionIcon + ' ' + iconPremier}></span>
        </div>
    return (
        <div className={tileItemName}
            data-itemtype={props.TypeKey}
            data-itemindex={props.Index}>
            <div className='content'>
                {iconShow}
                <a href={linkUrl} target={linkTarget} onClick={handleLinkClicked}>
                    <div className={titleClass}>{props.Title}</div>
                    <div className='description'>{props.Description}</div>
                </a>
                <div className='recommended-wrapper' style={recommendedStyle}>
                    <div className="recommended">
                        <h5>Recommended option</h5>
                    </div>
                    <div className="recommended-indicator"><span></span><i></i></div>
                </div>
            </div>
        </div>
    );
}

export { Tile }